import {
  SET_NAVBAR_CONVERSATIONS,
  SET_CONVERSATIONS,
  SET_CONVERSATIONS_DETAILS,
  SET_MESSAGES,
  INCREASE_LIMIT,
  SET_TOTAL_MESSAGES,
  RESET_CHAT,
  SET_CURRENT_ITEMS,
  SET_CURRENT_TOGGLE_ITEM_FUNCTION,
  SET_ASSIGN_SEARCH_VALUE,
  SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_SHOW_SELECTED_ITEMS,
  SET_CURRENT_TAB,
  SET_SELECTED_ORG_GROUPS,
  SET_SELECTED_USERS,
  SET_SELECTED_LOCATION_GROUPS,
  SET_SELECTED_LOCATIONS,
  SET_SELECTED_ROLES,
  SET_SELECTED_STORES,
  SET_SHOW_SELECTED_ORG_GROUPS,
  SET_SHOW_SELECTED_USERS,
  SET_SHOW_SELECTED_LOCATION_GROUPS,
  SET_SHOW_SELECTED_STORES,
  SET_SHOW_SELECTED_ROLES,
  SET_SHOW_SELECTED_LOCATIONS,
  SET_SELECTED_ROLES_FILTER,
  SET_SHOW_SELECTED_USERS_ITEMS,
  SET_ALL_USERS,
  SET_CREATING_CONVERSATION_LOADING,
  SET_LOADING_MORE,
  SET_ARCHIVING_MESSAGES,
  SET_EDITED_MESSAGES,
  SET_GROUP_MEMBERS,
  SET_LOADING_CONVERSATIONS,
  SET_LOADING_MESSAGES
} from './constants'

const initialState = {
  navbarConversations: [],
  conversations: [],
  activeConversation: {},
  messages: [],
  limit: 20,
  totalMessages: 0,
  editedMessages: 0,
  currentItems: 'groupOrgs',
  currentToggleFunction: 'toggleOrgGroups',
  assignSearchValue: '',
  currentHideSelectedItemsFunction: 'setHideSelectedOrgGroups',
  currentShowSelectedItemsFunction: 'setShowSelectedOrgGroups',
  currentShowSelectedItems: 'showSelectedOrgGroups',
  assignSearchValue: '',
  selectedOrgGroups: [],
  selectedUsers: [],
  selectedLocationGroups: [],
  selectedLocations: [],
  selectedRoles: [],
  selectedStores: [],
  showSelectedOrgGroups: false,
  showSelectedUsers: false,
  showSelectedUsersItems: false,
  showSelectedLocationGroups: false,
  showSelectedLocations: false,
  showSelectedStores: false,
  showSelectedRoles: false,
  allUsers: [],
  creatingNewConversation: false,
  loadingMore: false,
  archivingMessages: false,
  groupMembers: [],
  loadingConversations: false,
  loadingMessages: false,
}

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NAVBAR_CONVERSATIONS:
      return {
        ...state,
        navbarConversations: action.payload,
      }
    case SET_ALL_USERS:
      return {
        ...state,
        allUsers: action.payload,
      }
    case SET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload,
      }
    case SET_CONVERSATIONS_DETAILS:
      return {
        ...state,
        activeConversation: action.payload,
      }
    case SET_MESSAGES:
      return {
        ...state,
        messages: action.payload,
      }
    case INCREASE_LIMIT:
      return {
        ...state,
        limit: state.limit + 20,
      }
    case SET_TOTAL_MESSAGES:
      return {
        ...state,
        totalMessages: action.payload,
      }
    case SET_EDITED_MESSAGES:
      return {
        ...state,
        editedMessages: action.payload,
      }
    case SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.currentTab,
      }
    case SET_SELECTED_ORG_GROUPS:
      return {
        ...state,
        selectedOrgGroups: action.orgGroups,
      }
    case SET_SELECTED_USERS:
      return {
        ...state,
        selectedUsers: action.users,
      }
    case SET_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        selectedLocationGroups: action.locationGroups,
      }
    case SET_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.locations,
      }
    case SET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case SET_SELECTED_STORES:
      return {
        ...state,
        selectedStores: action.stores,
      }
    case RESET_CHAT:
      return {
        ...state,
        messages: [],
        limit: 20,
        totalMessages: 0,
      }
    case SET_CURRENT_ITEMS:
      return {
        ...state,
        currentItems: action.currentItems,
      }
    case SET_CURRENT_TOGGLE_ITEM_FUNCTION:
      return {
        ...state,
        currentToggleFunction: action.currentToggleFunction,
      }
    case SET_ASSIGN_SEARCH_VALUE:
      return {
        ...state,
        assignSearchValue: action.assignSearchValue,
      }
    case SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentHideSelectedItemsFunction:
          action.currentHideSelectedItemsFunction,
      }
    case SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentShowSelectedItemsFunction:
          action.currentShowSelectedItemsFunction,
      }
    case SET_CURRENT_SHOW_SELECTED_ITEMS:
      return {
        ...state,
        currentShowSelectedItems: action.currentShowSelectedItems,
      }
    case SET_SHOW_SELECTED_ORG_GROUPS:
      return {
        ...state,
        showSelectedOrgGroups: action.showSelectedOrgGroups,
      }
    case SET_SHOW_SELECTED_USERS:
      return {
        ...state,
        showSelectedUsers: action.showSelectedUsers,
      }
    case SET_SHOW_SELECTED_USERS_ITEMS:
      return {
        ...state,
        showSelectedUsersItems: action.showSelectedUsersItems,
      }
    case SET_SHOW_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        showSelectedLocationGroups: action.showSelectedLocationGroups,
      }
    case SET_SHOW_SELECTED_LOCATIONS:
      return {
        ...state,
        showSelectedLocations: action.showSelectedLocations,
      }
    case SET_SHOW_SELECTED_STORES:
      return {
        ...state,
        showSelectedStores: action.showSelectedStores,
      }
    case SET_SHOW_SELECTED_ROLES:
      return {
        ...state,
        showSelectedRoles: action.showSelectedRoles,
      }
    case SET_SELECTED_ROLES_FILTER:
      return {
        ...state,
        rolesFilter: action.value,
      }

    case SET_CREATING_CONVERSATION_LOADING:
      return {
        ...state,
        creatingNewConversation: action.payload,
      }

    case SET_LOADING_MORE:
      return {
        ...state,
        loadingMore: action.payload,
      }

    case SET_ARCHIVING_MESSAGES:
      return {
        ...state,
        archivingMessages: action.payload,
      }

    case SET_GROUP_MEMBERS:
      return { ...state, groupMembers: action.payload }


    case SET_LOADING_CONVERSATIONS:
      return {...state, loadingConversations: action.loading}

    case SET_LOADING_MESSAGES:
      return {...state, loadingMessages: action.loading}  

    default:
      return state
  }
}

export default chatReducer
